import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { LoaderService } from './loader.service';

@Component({
  selector: 'z-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent implements OnInit {
  readonly #loaderService = inject(LoaderService);

  isLoading = signal(false);

  ngOnInit(): void {
    this.#loaderService.loaderState.subscribe(loading => {
      this.isLoading.set(loading);
    });
  }
}
